import * as React from 'react';
import IconButton from '../../common/IconButton';

interface PageJumpToolButtonsProps {
  onNumButtonsClick: (num: number) => void;
  onClearButtonClick: () => void;
}

const containerStyle: React.CSSProperties = {
  display:'flex',
  padding: '10px 10px 10px 10px',
  width: '192px',
  marginTop: 0,
  flexWrap: 'wrap',
};

const buttonStyle: React.CSSProperties = {
  margin: '10px',
  width: '44px',
  height: '40px',
};

const buttonImageStyle: React.CSSProperties = {
  width: '44px',
  height: '40px',
};

const PageJumpToolButtons: React.SFC<PageJumpToolButtonsProps> = (props) => {
  const { onNumButtonsClick, onClearButtonClick } = props;

  return (
    <div style={containerStyle}>
      <IconButton imagePath="images/page-navigator/number/btn_01"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(1)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_02"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(2)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_03"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(3)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_04"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(4)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_05"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(5)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_06"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(6)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_07"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(7)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_08"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(8)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_09"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(9)}
        />
      <div style={buttonStyle} />
      <IconButton imagePath="images/page-navigator/number/btn_00"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={() => onNumButtonsClick(0)}
        />
      <IconButton imagePath="images/page-navigator/number/btn_clear"
        style={buttonStyle}
        imageStyle={buttonImageStyle}
        svgStyle={buttonImageStyle}
        onClick={onClearButtonClick}
        />
    </div>
  );
};

export default PageJumpToolButtons;
